/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPaymentSuspended = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M15.318 15.318a4.499 4.499 0 1 1 6.364 6.362 4.499 4.499 0 0 1-6.364-6.362zm2.269 5.508a2.499 2.499 0 0 0 3.24-3.24zm1.825-4.653a2.5 2.5 0 0 0-3.24 3.24z" />
        <path d="M24 14h-2V5H2v14h10v2H0V3h24z" />
        <path d="M13 7h3v2h-3v2h1a3 3 0 0 1 2.598 1.499l-1.73 1.002A1 1 0 0 0 14 13h-1v5h-2v-1H8v-2h3v-2h-1a3 3 0 1 1 0-6h1V6h2zm-3 2a1 1 0 0 0 0 2h1V9z" />
      </g>
    </g>
  </Icon>
);
export { SvgPaymentSuspended as PaymentSuspended };
